import React, { FC } from 'react'
import styled from 'styled-components'

type Props = {
  children: string
  multiline?: boolean
  maxLength?: number
}

const Ellipsis: FC<Props> = (props) => {
  const { children, maxLength, multiline } = props

  if (multiline) {
    if (!maxLength) {
      throw new Error('maxLength is undefined')
    }
    return (
      <EllipsisMultiline>
        {children?.substring(1, maxLength)}
        {children?.length && children?.length > maxLength ? '...' : ''}
      </EllipsisMultiline>
    )
  } else {
    return <EllipsisOneLine>{children}</EllipsisOneLine>
  }
}

export default Ellipsis

const EllipsisOneLine = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const EllipsisMultiline = styled.div`
  word-break: break-all;
`
